import { IconButton } from '@aia/ui/atoms';
import { type LinkProps, useCanGoBack, useRouter } from '@tanstack/react-router';
import { ChevronLeft } from 'lucide-react';
import { twMerge } from 'tailwind-merge';

export type BackButtonProps = {
  className?: string;
  fallbackUrl?: LinkProps['to'];
  params?: LinkProps['params'];
  search?: LinkProps['search'];
};

export function BackButton({
  className,
  fallbackUrl,
  params,
  search,
}: BackButtonProps): React.ReactElement {
  const canGoBack = useCanGoBack();
  const router = useRouter();

  const goBack = () => {
    router.history.back();
  };

  const classNames = twMerge('bg-gray-50 w-fit rounded-full p-2', className);

  const handleClick = () => {
    if (canGoBack) {
      goBack();
    } else if (fallbackUrl) {
      router.navigate({
        to: fallbackUrl,
        params,
        search,
      });
    }
  };

  return (
    <IconButton textColor="foreground" className={classNames} onClick={handleClick}>
      <ChevronLeft strokeWidth={1.5} size={24} />
    </IconButton>
  );
}
